import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { Device, breakpoint } from "../../../components/device";
import { TrackType } from "../../../components/types";
import { rgba } from "polished";
import Icon from "../Icon/Icon";
//import { Waypoint } from "react-waypoint";

type direction = "left" | "right";

/*
Usage:
<Slider
    header="Galleri"
    columnWidth={3}
    controlsColor="white"
    moreImagesLink="/"
    moreImagesText="Gallerier &amp; videoer">
    <!--Loop the following item wrapper-->
    <div className="slider__item">
    </div>
</Slider>
*/

/*
TO DO:
    - replace Item more images img to a tiny placeholder image
*/

interface SliderProps
{
    name?: string;
    buttons?: boolean;
    scrollbar?: boolean;
    columnWidth?: number; //1, 2, 3 or 4
    sliderType?: TrackType;
    controlsColor?: string;
    header?: string;
    moreImagesLink?: string;
    moreImagesText?: string;
}

const SliderWrap = styled.div`
    position: relative;
    overflow: hidden;
    overflow-x: scroll;

    ${Device.laptop} {
        overflow-x: hidden;
        padding-left: calc(50vw - 648px);
        padding-right: calc(50vw - 648px);
        //scroll-padding-left: 5rem;

        > button {
            display: none;
        }

        &:hover {
            > button {
                display: inline-block;
            }
        }
    }

    .grid-row.w-full & {
        margin-left: -1rem;
        margin-right: -1rem;
    }

    .slider__item {
        box-sizing: border-box;
        list-style: none;
        white-space: nowrap;
        display: list-item;
        text-align: -webkit-match-parent;
        flex-shrink: 0;
        scroll-snap-align: start;
        padding-left: .5rem;
        padding-right: .5rem;
        flex-basis: 75%;
        max-width: 75%;
        min-height: 50px;

        ${Device.laptop} {
            padding-left: 1rem;
            padding-right: 1rem;
            flex-basis: 100%;
            max-width: 100%;
        }
    }

    .slider-items--half .slider__item {
        flex-basis: 75%;
        max-width: 75%;

        ${Device.tablet} {
            flex-basis: 50%;
            max-width: 50%;
        }
    }

    .slider-items--third .slider__item {
        flex-basis: 75%;
        max-width: 75%;

        ${Device.tablet} {
            flex-basis: 33.33%;
            max-width: 33.33%;
        }
    }

    .slider-items--quarter .slider__item {
        flex-basis: 75%;
        max-width: 75%;

        ${Device.tablet} {
            flex-basis: 33.33%;
            max-width: 33.33%;
        }

        ${Device.tabletLandscape} {
            flex-basis: 25%;
            max-width: 25%;
        }
    }
`;

const SliderHeader = styled.h2`
    position: absolute;
    left: 1rem;
    top: 2rem;
    font-size: 3.5rem;
    text-transform: uppercase;
    opacity: .25;
    line-height: 1;
    font-weight: bold;
    letter-spacing: .25rem;
    transition: opacity .5s 1.5s;

    ${Device.tablet} {
        top: 3.5rem;
        font-size: 5rem;
        letter-spacing: .5rem;
    }

    ${Device.laptop} {
        font-size: 7rem;
        letter-spacing: 1rem;
    }

    &.in-view {
        opacity: 0;
    }
`;

const SliderGroupWrap = styled.div`

    transform: translateX(0);
    transition: transform 1s 1.5s;
    will-change: transform;

    /* 
    transform: translateX(100%);

    ${Device.tablet} {
        transform: translateX(50%);
    }

    &.in-view {
        transform: translateX(0);
    } 
    */

    .text-forcing-lazyload {
        opacity: 0;
    }
`;

const SliderGroup = styled.ul`
    display: flex;
    //flex-wrap: nowrap;
    flex-flow: row nowrap;
    margin: 0;
    max-width: 100%;
    padding: 0 .5rem;
    list-style: none;
    white-space: nowrap;
    scrollbar-width: none;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    scroll-padding-left: 1rem;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    transform: translateZ(0);
    transition: transform .5s ease-out;
    will-change: transform;

    &::-webkit-scrollbar {
        display: none;
    }

    &:after {
        //right padding scroll fix
        content:"";
        height: 50px;
        box-sizing: border-box;
        list-style: none;
        white-space: nowrap;
        display: list-item;
        text-align: -webkit-match-parent;
        flex-shrink: 0;
        max-width: .5rem;
        flex-basis: .5rem;

        ${Device.laptop} {
            display: none;
        }
    }

    ${Device.laptop} {
        padding-left: 0;
        padding-right: 0;
    }

    @media(max-width: ${breakpoint.Medium}){
        transform: none !important;
    }
`;

const Progress = styled.div<SliderProps>`
    cursor: pointer;
    display: none;
    margin: 0 auto;
    max-width: 290px;
    min-height: 50px;
    padding-left: 25px;
    padding-right: 25px;
    position: relative;

    &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 2px;
        background-color: ${props => (props.controlsColor) ? `${rgba(props.controlsColor, 0.25)};` : "lightgray"};
    }

    ${Device.laptop} {
        display: block;
        max-width: 400px;
    }

    div {
        width: 50px;
        height: 100%;
        min-height: inherit;
        pointer-events: none;
        transition: all .3s ease-in-out;
        position: relative;
        &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 2px;
            background-color: ${props => (props.controlsColor) ? `${rgba(props.controlsColor, 0.9)};` : "black"};
        }
        &.drag {
            transition: none;
        }
    }

    &.dot {
        min-height: 50px;
        background: transparent;

        &:before{
            content: "";
            min-height: 10px;
            position: absolute;
            left: 0;
            background: teal;
            width: 100%;
            top: 50%;
            margin-top: -5px;
        }

        div {
            width: 50px;
            border-radius: 50px;
            position: relative;
            z-index: 1;
        }
    }
`;

const Navigation = styled.button<SliderProps>`
    border-width: 2px;
    border-style: solid;
    border-color: ${props => (props.controlsColor) ? `${rgba(props.controlsColor, .9)};` : "darkgray"};
    border-radius: 50%;
    color: ${props => (props.controlsColor) ? `${rgba(props.controlsColor, .9)};` : "darkgray"};
    display: none;
    padding: 5px;
    position: absolute;
    top: calc(50% - 65px);
    width: 50px;
    height: 50px;
    line-height: 1;
    pointer-events: none;
    opacity: 0;
    outline: none;
    text-align: center;
    text-shadow: 0 0 63px rgba(0,0,0,.3);
    transition: all .15s linear;
    &:focus, &:hover {
        outline: none;
        transform: scale(.95);
    }
    &.active {
        opacity: 1;
        pointer-events: inherit;
    }
    &.left {
        left: 10px;
    }
    &.right {
        right: 10px;
    }
    ${Device.laptop} {
        display: block;
        &.left{
            left: calc(50% - 648px);
        }
        &.right{
            right: calc(50% - 648px);
        }
    }
`;

const Slider: React.FunctionComponent<SliderProps> = (props) =>
{
    const { buttons = true, scrollbar = true, columnWidth = 4, sliderType = TrackType.Default } = props;
    const slider = useRef<HTMLUListElement>(null);
    const track = useRef<HTMLDivElement>(null);
    const [perc, updatePerc] = useState(0);
    const [current, updateCurrent] = useState(0);
    const [isDown, toggleDown] = useState(false);
    const [checkStart, toggleStart] = useState(false);
    const max = slider.current ? Math.floor(slider.current.childElementCount / columnWidth) : 0;

    //In View state
    const [inView] = useState(false);

    useEffect(() =>
    {
        if (slider.current !== null)
        {
            const maxStart = Math.floor(slider.current.childElementCount / columnWidth);
            if (maxStart !== 0)
            {
                toggleStart(true);
            }
        }
    }, [columnWidth]);


    const updateTrack = (value: number) =>
    {
        if (track.current !== null)
        {
            const element = track.current.getBoundingClientRect();
            let trackValue = ((value - element.left) / element.width);
            if (trackValue < 0)
            {
                trackValue = 0;
            }
            if (trackValue > 1)
            {
                trackValue = 1;
            }
            if (slider.current)
            {
                const trackPercentage = trackValue * 100;
                const currentPage = Math.round((max / 100) * trackPercentage);
                updateCurrent(current => currentPage);
            }
            updatePerc((trackValue * 100));
        }
    };

    const frameUpdate = (x: number) => () =>
    {
        updateTrack(x);
    };

    const onTrackUpdateChange = (e: MouseEvent) =>
    {
        e.preventDefault();
        requestAnimationFrame(frameUpdate(e.pageX));
    };

    const onTrackUp = (e: Event) =>
    {
        window.removeEventListener("mousemove", onTrackUpdateChange);
        window.removeEventListener("mouseup", onTrackUp);
        toggleDown(false);
    };

    const onTrackDown = (e: React.SyntheticEvent<HTMLDivElement>) =>
    {
        window.addEventListener("mousemove", onTrackUpdateChange);
        window.addEventListener("mouseup", onTrackUp);
        toggleDown(true);
    };

    const onTrackClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    {
        if (track.current !== null && slider.current !== null)
        {
            const element = track.current.getBoundingClientRect();
            const trackValue = ((e.pageX - element.left) / element.width);
            const trackPercentage = trackValue * 100;
            if (trackPercentage < 5)
            {
                updateTrack(0);
            }
            else if (trackPercentage > 90)
            {
                updateTrack(slider.current.clientWidth);
            }
            else
            {
                updateTrack(e.pageX);
            }
        }
    };


    const onNavClick = (dir: direction) => (e: React.SyntheticEvent) =>
    {
        const counter = dir === "left" ? -1 : 1;
        if (slider.current)
        {
            let c = current;
            if (current < 0)
            {
                c = 0;
                updateCurrent(current => c);
            }
            else if (current >= 0 && counter > 0)
            {
                if (current > max - 1)
                {
                    c = max;
                    updateCurrent(current => c);
                }
                else
                {
                    c = c + 1;
                    updateCurrent(current => c);
                }
            }
            else
            {
                c = c - 1;
                if (c < 0)
                {
                    c = 0;
                    updateCurrent(current => c);
                }
                else
                {
                    updateCurrent(current => c);
                }
            }

            let pencentage = ((100 / max) * c);
            if (pencentage > 100)
            {
                pencentage = 100;
            }
            updatePerc(pencentage);
        }
    };

    const getValue = () =>
    {
        if (perc > 100)
        {
            return 100;
        }
        if (perc < 0)
        {
            return 0;
        }
        return perc;
    };

    const checkPosition = () =>
    {
        const container = slider.current;
        if (container)
        {
            const val = container.scrollWidth - container.clientWidth;
            return -((val / 100) * perc);
        }
    };

    const checkCount = (dir: direction) =>
    {
        if (slider.current !== null)
        {
            switch (dir)
            {
                case "left":
                    return current !== 0 ? "active" : "";
                case "right":
                    return current !== max ? "active" : "";
            }
        }
        if (checkStart && dir === "right")
        {
            return "active";
        }
    };

    const checkItemWidth = () =>
    {
        if (columnWidth === 4)
        {
            return "slider-items--quarter";
        }
        if (columnWidth === 3)
        {
            return "slider-items--third";
        }
        if (columnWidth === 2)
        {
            return "slider-items--half";
        }

        return "";
    };

    return (
        <SliderWrap>

            {props.header ?
                <div className="container mx-auto relative">
                    <SliderHeader className={inView ? "in-view" : ""}>{props.header}</SliderHeader>
                </div>
                : null}

            <SliderGroupWrap className={inView ? "in-view" : ""}>
                <div className="text-forcing-lazyload">Cast</div>
                <SliderGroup
                    ref={slider}
                    className={checkItemWidth()}
                    style={{
                        transform: `translate3d(${checkPosition()}px,0,0)`,
                        transition: isDown ? "transform .3s ease-out" : "transform .5s ease-out"
                    }}>
                    {props.children}
                </SliderGroup>
            </SliderGroupWrap>

            {buttons ? <>
                <Navigation onClick={onNavClick("left")} className={`left ${checkCount("left")}`} {...props}>
                    <Icon name="arrow-left-line" className="w-5 h-5 sm:w-7 sm:h-7" />
                </Navigation>
                <Navigation onClick={onNavClick("right")} className={`right ${checkCount("right")}`} {...props}>
                    <Icon name="arrow-right-line" className="w-5 h-5 sm:w-7 sm:h-7" />
                </Navigation>
            </> : null}

            {scrollbar ?
                <Progress
                    ref={track}
                    onMouseDown={onTrackDown}
                    onClick={onTrackClick}
                    className={`${sliderType !== TrackType.Default ? sliderType : ""}`}
                    {...props}>
                    <div className={`${isDown ? "drag" : ""}`} style={{ marginLeft: `calc(${getValue()}% - 25px)` }} ></div>
                </Progress>
                : null}
        </SliderWrap>
    );
};

export default Slider;